import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { LanguageSwitcher } from './language-switcher';
import { SCORM_DOWNLOAD_PRICING } from '../../lib/features';

export function Footer() {
  const { t, i18n } = useTranslation();
  const { lang } = useParams<{ lang: string }>();
  const currentLang = lang || i18n.language || 'en';
  const home = `/${currentLang}/`;

  return (
    <footer className="site-footer">
      <div className="wrap footer-main">
        <div>
          <Link className="brand" to={home}><img src="/brand/scormate-logo-color-480.png" alt="Scormate" width="480" height="127" /></Link>
          <p>{t('site.footer.tagline')}</p>
          <span className="small muted">{t('site.footer.company')}</span>
        </div>
        <nav aria-label={t('site.footer.product')}>
          <strong>{t('site.footer.product')}</strong>
          <a href={`${home}#converter`}>{t('site.footer.productConverter')}</a>
          <a href={`${home}#ai-builder`}>{t('site.footer.productAi')}</a>
          {SCORM_DOWNLOAD_PRICING && <a href={`${home}#pricing`}>{t('site.footer.productPricing')}</a>}
        </nav>
        <nav aria-label={t('site.footer.help')}>
          <strong>{t('site.footer.help')}</strong>
          <a href={`${home}#faq`}>{t('site.footer.helpFaq')}</a>
          <a href="mailto:scormate@coloris.com.ua">scormate@coloris.com.ua</a>
          <Link className="text-button" to={`/${currentLang}/privacy-policy`}>{t('site.footer.privacy')}</Link>
          <Link to={`/${currentLang}/terms-of-use`}>{t('site.footer.terms')}</Link>
        </nav>
      </div>
      <div className="wrap footer-bottom">
        <span>© {new Date().getFullYear()} Colorisoft</span>
        <LanguageSwitcher up />
      </div>
    </footer>
  );
}
